export default {"src":"/_next/static/media/tnc.aad73e95.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};